// Operator HTML policy in the templates (MOB-121, ADR 0011).
//
// `$safeHtml(value)` is the only expression that a `v-html` may hold: the lint rule
// `vue/no-restricted-syntax` in eslint.config.mjs reports any other. `$safeUrl(value)` takes an
// operator URL for an `href` or `src` binding and gives undefined (no attribute) for an unsafe
// scheme. `$plainText(value)` gives the text of operator HTML (all elements removed, all entities
// decoded) for a place that cannot show HTML: an attribute such as `alt`, a breadcrumb (MOB-461,
// doctrine E87).
import { safeHtml, safeUrl, plainText } from '@/libs/HtmlUtil'

export default {
  install(app) {
    app.config.globalProperties.$safeHtml = safeHtml
    app.config.globalProperties.$safeUrl = safeUrl
    app.config.globalProperties.$plainText = plainText
  },
}
